import React, { useEffect, useRef } from "react";
import "./Endofpartpopupcdmqb.css";
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.
//
// Shown when the user presses Next (submit step). Styled like the CDMQB
// test page's "End Review" confirmation popup.

export default function EndOfPartPopupCDMQB(props) {
  const noButtonRef = useRef(null);

  useEffect(() => {
    if (!props.displayEndOfPartPopup) return;

    // Default focus on "No" so Enter doesn't accidentally lock the part.
    if (noButtonRef.current) noButtonRef.current.focus();

    // Escape / N = No, Y = Yes (matches the underlined access keys).
    const handleKeyDown = (event) => {
      if (event.ctrlKey || event.metaKey) return;
      const key = event.key.toLowerCase();
      if (key === "escape" || key === "n") {
        event.preventDefault();
        props.cancelEndOfPart();
      } else if (key === "y") {
        event.preventDefault();
        props.confirmEndOfPart();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    props.displayEndOfPartPopup,
    props.cancelEndOfPart,
    props.confirmEndOfPart,
  ]);

  if (!props.displayEndOfPartPopup) return null;

  return (
    <div className="endOfPartPageContainerCDMQB">
      <div className="endOfPartBackdropCDMQB" />
      <div
        className="endOfPartContainerCDMQB"
        role="dialog"
        aria-modal="true"
        aria-labelledby="endOfPartHeaderCDMQB"
        aria-describedby="endOfPartBodyCDMQB"
      >
        <div className="endOfPartHeaderContainerCDMQB">
          <h2 id="endOfPartHeaderCDMQB" className="endOfPartHeaderTextCDMQB">
            End of Part
          </h2>
          <button
            type="button"
            className="endOfPartCloseButtonCDMQB"
            aria-label="Close"
            onClick={props.cancelEndOfPart}
          />
        </div>

        <div className="endOfPartBodyContainerCDMQB">
          <svg
            className="endOfPartIconCDMQB"
            viewBox="0 0 32 32"
            aria-hidden="true"
          ></svg>
          <p id="endOfPartBodyCDMQB" className="endOfPartBodyTextCDMQB">
            You will not be able to go back. Do you wish to continue?
          </p>
        </div>

        <div className="endOfPartFooterContainerCDMQB">
          <button
            type="button"
            className="endOfPartFooterButtonCDMQB"
            onClick={props.confirmEndOfPart}
          >
            <span className="endOfPartAccessKeyCDMQB">Y</span>es
          </button>
          <button
            type="button"
            ref={noButtonRef}
            className="endOfPartFooterButtonCDMQB"
            onClick={props.cancelEndOfPart}
          >
            <span className="endOfPartAccessKeyCDMQB">N</span>o
          </button>
        </div>
      </div>
    </div>
  );
}
